module.exports = __webpack_public_path__ + "img/1c.2cde2ffa.svg";